import {Filtro} from './filtro';
import {RotaVo} from '../../vo/rota-vo';

export class FiltroVoid implements Filtro<RotaVo> {

  filtrar(array: RotaVo[]): RotaVo[] {
    return [];
  }

  getComparador(): string {
    return '';
  }

  getFiltroNome(): string {
    return '';
  }

  setComparadores(comparadores: string[]): void {
  }

  addComparador(comparador: string): void {
  }

  addComparadores(comparadores: string[]): void {
  }

  getComparadores(): string[] {
    return [];
  }

}
